module.exports = __webpack_public_path__ + "img/lg.eb004663.png";